//@author: devin
import { type DropDownItem } from "../../../pojo/DropDownItem";

export type Extractable<T> =
    | T
    | {
          itemId?: T;
          val?: T;
          id?: T;
          itemName?: string;
          txt?: string;
          name?: string;
      };

export class GenericDropdownUtil {
    public static extractItems<U extends string | number, T extends Extractable<U>>(
        data?: T[],
    ): DropDownItem<U>[] | undefined {
        if (!data) return undefined;
        return data.map((obj) => GenericDropdownUtil.extractItem<U, T>(obj));
    }

    public static extractItem<U extends string | number, T extends Extractable<U>>(obj: T): DropDownItem<U>;
    public static extractItem<U extends string | number, T extends Extractable<U>>(
        obj?: T,
    ): DropDownItem<U> | undefined;
    public static extractItem<U extends string | number, T extends Extractable<U>>(
        obj?: T,
    ): DropDownItem<U> | undefined {
        if (!obj) return undefined;
        if (typeof obj === "string" || typeof obj === "number") {
            return <DropDownItem<U>>{ itemId: obj, itemName: obj.toString() };
        }

        obj.val ??= obj.itemId ?? obj.id;
        obj.txt ??= obj.itemName ?? obj.name;
        obj.itemId ??= obj.val ?? obj.id;
        obj.itemName ??= obj.txt ?? obj.name;

        return <DropDownItem<U>>obj;
    }

    public static addGroups(items: DropDownItem[], groupProp: string = "grp") {
        const groups = new Set<string>();
        let i = 0;
        while (i < items.length) {
            const item = items[i];
            item.grp = item[groupProp];
            if (item[groupProp] && !groups.has(item[groupProp])) {
                groups.add(item[groupProp]);
                items.splice(i, 0, { isGroup: true, groupName: item[groupProp] });
            }
            i++;
        }
        return items;
    }

    public static getId<T extends number | string = number | string>(item: Pick<DropDownItem<T>, "itemId" | "val">): T {
        return (item.itemId ?? item.val)!;
    }

    public static getName(item: DropDownItem): string {
        return (item.itemName ?? item.txt)!;
    }
}
